/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  DeleteUserOptions,
  DeleteUserStatus200,
  DeleteUserStatus401,
  DeleteUserStatus403,
  DeleteUserStatus404,
} from '../types/DeleteUser'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deleteUser } from '../clients/deleteUser'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deleteUserMutationKey = () => [{ url: '/v1/user/:user_id' }] as const

export function deleteUserMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = deleteUserMutationKey()
  return mutationOptions<
    DeleteUserStatus200,
    ResponseErrorConfig<DeleteUserStatus401 | DeleteUserStatus403 | DeleteUserStatus404>,
    DeleteUserOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return deleteUser({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Delete user by ID
 * {@link /v1/user/:user_id}
 */
export function useDeleteUser<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeleteUserStatus200,
      ResponseErrorConfig<DeleteUserStatus401 | DeleteUserStatus403 | DeleteUserStatus404>,
      DeleteUserOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deleteUserMutationKey()

  const baseOptions = deleteUserMutationOptions(config) as UseMutationOptions<
    DeleteUserStatus200,
    ResponseErrorConfig<DeleteUserStatus401 | DeleteUserStatus403 | DeleteUserStatus404>,
    DeleteUserOptions,
    TContext
  >

  return useMutation<
    DeleteUserStatus200,
    ResponseErrorConfig<DeleteUserStatus401 | DeleteUserStatus403 | DeleteUserStatus404>,
    DeleteUserOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeleteUserStatus200,
    ResponseErrorConfig<DeleteUserStatus401 | DeleteUserStatus403 | DeleteUserStatus404>,
    DeleteUserOptions,
    TContext
  >
}
